export const
  ERROR_RESET = 'error_reset';
export const ERROR = 'error_generic';
export const INFO_RESET = 'info_reset';
export const INFO = 'info_generic';



// WEBPACK FOOTER //
// ./src/store/infos/types.js